export function isTestingServer() {
  const testServers = [
    "localhost",
    "develop.augmentt.com",
    "staging.augmentt.com",
    "beta.augmentt.com",
    "test.augmentt.com",
    "develop-testing.augmentt.com",
  ];
  const currentOrigin = window.location.origin;
  const tesetServer = testServers.find((server) =>
    currentOrigin.includes(server),
  );
  return !!tesetServer;
}
